import React, { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as appActions from "../../core/app.store";
import * as config from '../../common/config'
import dayjs from 'dayjs';

import headCellsSendToShipper from './head-cell-send-to-shipper';
import DataTableSarang from '../../components/datatable-sarang';
import { getUserInfo } from "../../utils/configuration";

import * as herdsmanManagementAction from "../../redux/store-sarang/herdsman/herdsman-management.store";
import * as branchManagementAction from "../../redux/store-sarang/branch/branch-management.store";
import * as accountManagementAction from "../../redux/store/account/account.store";

import FormSearchWrapperSarang from '../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import { useMediaQuery } from 'react-responsive';
import MobileHeaderSarang from '../../components/mobile-header/mobile-header-sarang';

import { useSumaryDeliveryData } from './hooks/useSumaryDeliveryData';
import { useShipperActions } from './hooks/useShipperActions';
import { ShipperSearchForm } from './components/ShipperSearchForm';
import { ShipperModals } from './components/ShipperModals';
import { ShipperTableDesktop, ShipperTableMobile } from './components/ShipperTable';

const configLocal = {
    defaultPageSize: config.Configs.DefaultPageSize,
    sortExpression: "orderDate desc" + (new Date().getHours() <= 13 ? ', receiptTime asc, commune.District.Name asc, commune.Name asc' : ', receiptTime desc, commune.District.Name asc, commune.Name asc'),
    orderBy: "orderDate",
    order: "desc",
}

export default function SendCuisineToShipper() {
    const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1023px)" });

    const dispatch = useDispatch();
    const showLoading = (data) => dispatch(appActions.ShowLoading(data));
    // Hôm nay theo lịch Việt Nam (nửa đêm local) để mặc định "Từ ngày" không bị lệch múi giờ máy
    const [now] = useState(dayjs(dayjs().tz().format('YYYY-MM-DD')));
    const [currentUser] = useState(getUserInfo());

    const { register, handleSubmit, setValue, control, reset } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
        defaultValues: {
            deliveryFromDate: dayjs(now).format("YYYY-MM-DD"),
            deliveryToDate: dayjs(now).format("YYYY-MM-DD"),
            receiptTime: null,
            branchId: currentUser?.branchId || null,
            herdsmanDeliveryId: null,
            transportStatus: null
        }
    });

    const [herdsmanAll, setHerdsmanAll] = useState([]);
    const [branch, setBranch] = useState([]);
    const [searchData, setSearchData] = useState();
    const [cuisineData, setCuisineData] = useState([]);

    const {
        data, sumaryCuisine, GetSumaryDelivery
    } = useSumaryDeliveryData(showLoading);

    const buttonOpenConfirmRef = React.useRef();

    const actions = useShipperActions({
        showLoading, GetSumaryDelivery, searchData, buttonOpenConfirmRef, setCuisineData
    });

    const [openSearch, setOpenSearch] = useState(false);

    useEffect(() => {
        const initialDate = dayjs(now).format("YYYY-MM-DD");
        setValue("deliveryFromDate", initialDate);
        setValue("deliveryToDate", initialDate);
        setSearchData({ deliveryFromDate: initialDate, deliveryToDate: initialDate });

        const getLookupBranch = async () => {
            try {
                const res = await branchManagementAction.GetLookupBranch();
                if (res && res.content) setBranch(res.content);
            } catch (err) { console.error(err); }
        };

        const getUserDetail = async () => {
            try {
                const res = await accountManagementAction.GetDetailAcc();
                if (res && res.content) {
                    const branchId = res.content.branchId;
                    if (branchId) {
                        setValue("branchId", branchId);
                        const initialQuery = { deliveryFromDate: initialDate, deliveryToDate: initialDate, branchId };
                        setSearchData(initialQuery);
                        GetSumaryDelivery(initialQuery);
                        return;
                    }
                }
                GetSumaryDelivery({ deliveryFromDate: initialDate, deliveryToDate: initialDate });
            } catch (err) {
                GetSumaryDelivery({ deliveryFromDate: initialDate, deliveryToDate: initialDate });
            }
        };

        const fetchHerdsman = async () => {
            showLoading(true);
            try {
                const res = await herdsmanManagementAction.GetLookupHerdsman(false);
                if (res && res.content && Array.isArray(res.content)) {
                    setHerdsmanAll(res.content.filter(item => item.id !== currentUser.herdsmanId));
                }
            } catch (err) { console.error(err); } finally { showLoading(false); }
        };

        getLookupBranch();
        getUserDetail();
        fetchHerdsman();
    }, []);

    const onSubmit = useCallback((data) => {
        setSearchData(data);
        GetSumaryDelivery(data);
        if (isTabletOrMobile) setOpenSearch(false);
    }, [GetSumaryDelivery, isTabletOrMobile]);

    const handleClearFilter = useCallback(() => {
        const initialDate = dayjs(now).format("YYYY-MM-DD");
        const initialStates = {
            deliveryFromDate: initialDate,
            deliveryToDate: initialDate,
            receiptTime: null,
            branchId: currentUser?.branchId || null,
            herdsmanDeliveryId: null,
            transportStatus: null
        };
        reset(initialStates);
        onSubmit(initialStates);
    }, [now, reset, onSubmit, currentUser]);

    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                {isDesktopOrLaptop && (
                    <>
                        <FormSearchWrapperSarang isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} hideNewButton={true}>
                            <ShipperSearchForm
                                handleSubmit={handleSubmit} onSubmit={onSubmit} register={register}
                                setValue={setValue} now={now} control={control} branch={branch}
                                herdsmanAll={herdsmanAll} isTabletOrMobile={isTabletOrMobile}
                                setOpenSearch={setOpenSearch}
                                handleClearFilter={handleClearFilter}
                            />
                        </FormSearchWrapperSarang>
                        <ShipperTableDesktop
                            data={data} sumaryCuisine={sumaryCuisine}
                            headCellsSendToShipper={headCellsSendToShipper}
                            handleRequestSort={() => {}} // Not implemented in original
                            order={configLocal.order} orderBy={configLocal.orderBy}
                            GetSumaryDelivery={GetSumaryDelivery} searchData={searchData}
                            handleDetailClick={actions.handleDetailClick}
                            setOpenActiveDialog={actions.setOpenActiveDialog}
                            openConfirmDialog={actions.openConfirmDialog}
                            DataTableSarang={DataTableSarang}
                        />
                    </>
                )}

                {isTabletOrMobile && (
                    <>
                        <ShipperTableMobile
                            data={data} headCellsSendToShipper={headCellsSendToShipper}
                            GetSumaryDelivery={GetSumaryDelivery} searchData={searchData}
                            setOrder={() => {}} setOrderBy={() => {}} // Not implemented in original
                            handleDetailClick={actions.handleDetailClick}
                            setOpenActiveDialog={actions.setOpenActiveDialog}
                            openConfirmDialog={actions.openConfirmDialog}
                            MobileHeaderSarang={MobileHeaderSarang}
                        />
                        <FormSearchWrapperSarang isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} hideNewButton={true}>
                            <ShipperSearchForm
                                handleSubmit={handleSubmit} onSubmit={onSubmit} register={register}
                                setValue={setValue} now={now} control={control} branch={branch}
                                herdsmanAll={herdsmanAll} isTabletOrMobile={isTabletOrMobile}
                                setOpenSearch={setOpenSearch}
                                handleClearFilter={handleClearFilter}
                            />
                        </FormSearchWrapperSarang>
                    </>
                )}
            </div>

            <ShipperModals
                anchorEl={actions.anchorEl}
                handleClosePopover={actions.handleClosePopover}
                cuisineData={cuisineData}
                buttonOpenConfirmRef={buttonOpenConfirmRef}
                isOpenActiveDialog={actions.isOpenActiveDialog}
                selectedItem={actions.selectedItem}
                closeConfirmDialog={actions.closeConfirmDialog}
                handleConfirm={actions.handleConfirm}
            />
        </div>
    );
}